import { useRoleStore } from '~/store/roleStore'

const ALLOWED_PREFIXES = ['/contracts', '/trust-accounting']

export default defineNuxtRouteMiddleware((to) => {
  if (import.meta.server) return

  const path = to.path
  if (path.startsWith('/auth') || path.startsWith('/public')) return

  const roleStore = useRoleStore()
  if (roleStore.roleCode !== 'AUDITOR') return

  const isAllowed = ALLOWED_PREFIXES.some(prefix => path.startsWith(prefix))
  if (!isAllowed) {
    return navigateTo('/contracts')
  }
})
